import React from 'react';
import { Check, Circle, CircleDashed, CirclePause, CircleDot, CircleDotDashed, Clock } from 'lucide-react';
import { LIBELLES_ETAT, LIBELLES_STATUT, type EtatClient, type StatutItem } from '../../lib/integrationApi';
import { formatDateFr } from '../../lib/formatDate';
import { Pastille } from '../Organisation/EtatsPage';

/** Pastilles de statut du dossier d'intégration : symbole ET texte, jamais la couleur seule. */

const ICONE_STATUT: Record<StatutItem, React.ComponentType<{ size?: number }>> = { a_demander: Circle, demande: CircleDashed, recu: CircleDotDashed, saisi: CircleDot, valide: Check };
const TON_STATUT: Record<StatutItem, 'neutre' | 'info' | 'warn' | 'ok'> = { a_demander: 'neutre', demande: 'info', recu: 'warn', saisi: 'info', valide: 'ok' };

export const PastilleStatutItem: React.FC<{ statut: StatutItem | null }> = ({ statut }) => {
    if (!statut) return <span className="text-content-muted text-[12px]">—</span>;
    const Icone = ICONE_STATUT[statut];
    return <Pastille ton={TON_STATUT[statut]} icone={<Icone size={11} />}>{LIBELLES_STATUT[statut]}</Pastille>;
};

export const PastilleEtat: React.FC<{ etat: EtatClient }> = ({ etat }) => {
    const m = { a_configurer: ['warn', Clock], operationnel: ['ok', Check], suspendu: ['danger', CirclePause] } as const;
    const [ton, Icone] = m[etat];
    return <Pastille ton={ton} icone={<Icone size={11} />}>{LIBELLES_ETAT[etat]}</Pastille>;
};

export const BarreAvancement: React.FC<{ pourcent: number }> = ({ pourcent }) => (
    <div className="flex items-center gap-2 min-w-[120px]">
        <div className="flex-1 h-2 rounded-full bg-surface-soft border border-border-soft overflow-hidden" role="progressbar" aria-valuenow={pourcent} aria-valuemin={0} aria-valuemax={100} aria-label="Avancement de l'intégration">
            <div className="h-full rounded-full" style={{ width: `${pourcent}%`, background: 'var(--acc)' }} />
        </div>
        <span className="text-[12px] font-semibold tabular-nums text-content w-9 text-right">{pourcent} %</span>
    </div>
);

export const dateFr = (iso: string | null) => formatDateFr(iso) || '—';
